module.exports = __webpack_public_path__ + "img/41-298b04.png";